/** @file imageDataUrl: an RGBA image as a `data:image/png;base64,` URL (stored deflate, no codec). */
import { encodePng } from '@zilo/pose3d-image-io/png/encodePng';
import type { Image } from '@zilo/pose3d-image-io/types/image';

/** PNG-encodes `image` (stored deflate: tiny tiles, no zlib) and base64s it into a data URL for an `<img>`. */
export async function imageDataUrl(image: Image): Promise<string> {
  const png = await encodePng(image, { filter: 'none' });
  let text = '';
  for (let i = 0; i < png.length; i += 0x8000) text += String.fromCharCode(...png.subarray(i, i + 0x8000));
  return `data:image/png;base64,${btoa(text)}`;
}
